/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Job_DurationInputs */

const en_job_duration = /** @type {(inputs: Job_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Job Duration`)
};

const fr_job_duration = /** @type {(inputs: Job_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Durée de la tâche`)
};

const de_job_duration = /** @type {(inputs: Job_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beschäftigungsdauer`)
};

const it_job_duration = /** @type {(inputs: Job_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Durata del lavoro`)
};

const ru_job_duration = /** @type {(inputs: Job_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Продолжительность работы`)
};

const es_job_duration = /** @type {(inputs: Job_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Duración del trabajo`)
};

const zh_cn2_job_duration = /** @type {(inputs: Job_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`工作时长`)
};

const ja_job_duration = /** @type {(inputs: Job_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`仕事の期間`)
};

const hi_job_duration = /** @type {(inputs: Job_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`नौकरी की अवधि`)
};

const pt_pt2_job_duration = /** @type {(inputs: Job_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Duração do trabalho`)
};

/**
* | output |
* | --- |
* | "Job Duration" |
*
* @param {Job_DurationInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const job_duration = /** @type {((inputs?: Job_DurationInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Job_DurationInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_job_duration(inputs)
	if (locale === "de") return de_job_duration(inputs)
	if (locale === "it") return it_job_duration(inputs)
	if (locale === "ru") return ru_job_duration(inputs)
	if (locale === "es") return es_job_duration(inputs)
	if (locale === "zh-CN") return zh_cn2_job_duration(inputs)
	if (locale === "ja") return ja_job_duration(inputs)
	if (locale === "hi") return hi_job_duration(inputs)
	if (locale === "pt-PT") return pt_pt2_job_duration(inputs)
	return en_job_duration(inputs)
});